

const Isload=(state=true,action)=>{
    switch(action.type){
        case 'SETLOADING':
            return false
        default:
            return state;
    }
}

export default Isload;